// forum_topics

import E621Type from "@/interfaces/E621";
declare const E621: E621Type;

import "@/pages/forum_posts/ForumPostVote";

E621.Registry.register("v_forum-topics_show");
